import React, { Component } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import ApiService from "../Services/ApiService";

import "../Styles/ofislerimiz.css";
import {
  MapPin,
  Tag,
  Phone,
  Globe,
  Navigation,
  Search,
  X,
  ChevronLeft,
  ChevronRight,
  Images,
  ArrowLeft,
  CheckCircle,
} from "lucide-react";

// Swiper components for gallery
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Scrollbar, Navigation as SwiperNavigation } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/scrollbar";
import "swiper/css/navigation";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

// Görsel yüklenemezse yerel logo (kapanan via.placeholder.com yerine)
const gorselYedeginiGoster = (e) => {
  e.target.onerror = null;
  e.target.src = "/Assets/Images/ut.png";
  e.target.style.objectFit = "contain";
  e.target.style.backgroundColor = "#f1f5f9";
};

class AnlasmaliKurumlar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kurumlar: [],
      filteredKurumlar: [],
      selectedKurum: null,
      loading: true,
      error: null,
      searchTerm: "",
      selectedCity: "",
      // Lightbox / Modal for photos
      isGalleryOpen: false,
      galleryImages: [],
      activeImageIndex: 0,
      activeKurumName: "",
    };
  }

  componentDidMount() {
    this.fetchKurumlar();
  }

  componentDidUpdate(prevProps) {
    const { id } = this.props.router.params;
    const prevId = prevProps.router.params.id;

    if (id !== prevId) {
      if (id) {
        const kurum = this.state.kurumlar.find((k) => k.id.toString() === id);
        if (kurum) {
          this.setState({ selectedKurum: kurum });
        } else {
          this.props.router.navigate("/anlasmali-kurumlar");
        }
      } else {
        this.setState({ selectedKurum: null });
      }
    }
  }

  formatImageUrl = (url) => {
    if (!url) return "";
    const clean = url.trim();
    if (clean.startsWith("//")) return "https:" + clean;
    if (clean.startsWith("http://") || clean.startsWith("https://")) return clean;
    if (clean.startsWith("www.")) return "https://" + clean;
    const baseUrl = ApiService.baseUrl || "https://nmuniversalteam.com";
    if (clean.startsWith("/")) return `${baseUrl}${clean}`;
    return `${baseUrl}/${clean}`;
  };

  fetchKurumlar = async () => {
    try {
      const res = await ApiService.get("/api/anlasmali-kurumlar/public");
      let data = [];
      if (Array.isArray(res)) {
        data = res;
      } else if (res && Array.isArray(res.data)) {
        data = res.data;
      }

      this.setState({
        kurumlar: data,
        filteredKurumlar: data,
        loading: false,
      }, () => {
        // Check router params for detail page
        const { id } = this.props.router.params;
        if (id) {
          const kurum = this.state.kurumlar.find((k) => k.id.toString() === id);
          if (kurum) {
            this.setState({ selectedKurum: kurum });
          }
        }
      });
    } catch (error) {
      console.error("Anlaşmalı kurumlar yüklenemedi:", error);
      this.setState({
        loading: false,
        error: "Anlaşmalı kurumlar yüklenirken bir hata oluştu.",
      });
    }
  };

  handleSearchChange = (e) => {
    const term = e.target.value;
    this.setState({ searchTerm: term }, this.filterData);
  };

  handleCityChange = (e) => {
    const city = e.target.value;
    this.setState({ selectedCity: city }, this.filterData);
  };

  filterData = () => {
    const { kurumlar, searchTerm, selectedCity } = this.state;
    const term = searchTerm.toLowerCase();

    const filtered = kurumlar.filter((item) => {
      const matchesSearch =
        !term ||
        (item.name && item.name.toLowerCase().includes(term)) ||
        (item.description && item.description.toLowerCase().includes(term)) ||
        (item.discount_rate && item.discount_rate.toLowerCase().includes(term)) ||
        (item.location && item.location.toLowerCase().includes(term));

      const matchesCity =
        !selectedCity ||
        (item.location && item.location.toLowerCase().includes(selectedCity.toLowerCase()));

      return matchesSearch && matchesCity;
    });

    this.setState({ filteredKurumlar: filtered });
  };

  openGallery = (images, initialIdx = 0, kurumName = "") => {
    const formatted = images.map((img) => this.formatImageUrl(img)).filter(Boolean);
    if (formatted.length > 0) {
      this.setState({
        isGalleryOpen: true,
        galleryImages: formatted,
        activeImageIndex: initialIdx,
        activeKurumName: kurumName || (this.state.selectedKurum ? this.state.selectedKurum.name : ""),
      });
    }
  };

  closeGallery = () => {
    this.setState({ isGalleryOpen: false, galleryImages: [] });
  };

  nextImage = () => {
    this.setState((prev) => ({
      activeImageIndex: (prev.activeImageIndex + 1) % prev.galleryImages.length,
    }));
  };

  prevImage = () => {
    this.setState((prev) => ({
      activeImageIndex:
        (prev.activeImageIndex - 1 + prev.galleryImages.length) % prev.galleryImages.length,
    }));
  };

  handleSelectKurum = (kurum) => {
    this.setState({ selectedKurum: kurum });
    this.props.router.navigate(`/anlasmali-kurumlar/${kurum.id}`);
  };

  handleBackToList = () => {
    this.setState({ selectedKurum: null });
    this.props.router.navigate("/anlasmali-kurumlar");
  };

  renderKurumDetail = () => {
    const { selectedKurum } = this.state;
    if (!selectedKurum) return null;

    const allImages = [];
    if (selectedKurum.image) allImages.push(selectedKurum.image);
    if (Array.isArray(selectedKurum.other_images)) {
      selectedKurum.other_images.forEach((img) => {
        if (img && !allImages.includes(img)) {
          allImages.push(img);
        }
      });
    }

    return (
      <div className="office-detail-container">
        {/* Header Hero Banner */}
        <div className="office-detail-header">
          <div className="office-detail-header-pattern" />

          <div className="container office-detail-header-container">
            <div className="row">
              <div className="col-lg-12">
                <button onClick={this.handleBackToList} className="back-button">
                  ← Anlaşmalı Kurumlara Dön
                </button>

                <div className="office-detail-header-content">
                  <div className="office-detail-title-container">
                    <h1 className="office-detail-title">{selectedKurum.name}</h1>
                  </div>

                  <div className="office-detail-meta">
                    {selectedKurum.location && (
                      <div className="office-detail-meta-item">
                        <MapPin size={16} />
                        {selectedKurum.location}
                      </div>
                    )}
                    {selectedKurum.discount_rate && (
                      <div className="office-detail-meta-item text-warning fw-bold">
                        <Tag size={16} />
                        {selectedKurum.discount_rate}
                      </div>
                    )}
                  </div>

                  {selectedKurum.description && (
                    <p className="office-detail-description">
                      {selectedKurum.description}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Image Banner */}
        {selectedKurum.image && (
          <div className="office-image-container">
            <div
              className="office-image-wrapper"
              onClick={() => this.openGallery(allImages, 0, selectedKurum.name)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={this.formatImageUrl(selectedKurum.image)}
                alt={selectedKurum.name}
                className="office-main-image"
                onError={(e) => {
                  gorselYedeginiGoster(e);
                }}
              />
            </div>
          </div>
        )}

        {/* Detail Content Section */}
        <div className="office-detail-content">
          <div className="container">
            <div className="row">
              {/* Left Main Column */}
              <div className="col-lg-8">
                {selectedKurum.address && (
                  <div className="office-info-card universal-card universal-shimmer mb-4">
                    <div className="office-info-card-pattern universal-pattern" />
                    <div className="office-info-card-content">
                      <h3 className="office-info-card-title">📍 Adres Bilgileri</h3>
                      <p className="office-info-card-text">{selectedKurum.address}</p>
                    </div>
                  </div>
                )}

                {selectedKurum.description && (
                  <div className="office-info-card universal-card universal-shimmer mb-4">
                    <div className="office-info-card-pattern universal-pattern" />
                    <div className="office-info-card-content">
                      <h3 className="office-info-card-title">🏷️ Kampanya & Kurum Detayı</h3>
                      <p className="office-info-card-text">{selectedKurum.description}</p>
                    </div>
                  </div>
                )}

                {/* Photo Gallery Swiper */}
                {allImages.length > 0 && (
                  <div className="office-gallery-card universal-card universal-shimmer mb-4">
                    <div className="office-gallery-card-pattern universal-pattern" />
                    <div className="office-gallery-card-content">
                      <h3 className="office-gallery-title">📷 Fotoğraflar ({allImages.length})</h3>
                      <Swiper
                        modules={[FreeMode, Scrollbar, SwiperNavigation]}
                        spaceBetween={15}
                        slidesPerView={"auto"}
                        freeMode={true}
                        scrollbar={{ draggable: true }}
                        navigation={true}
                        className="office-gallery-swiper"
                      >
                        {allImages.map((img, index) => (
                          <SwiperSlide key={index} className="gallery-slide">
                            <div
                              className="gallery-item"
                              onClick={() => this.openGallery(allImages, index, selectedKurum.name)}
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={this.formatImageUrl(img)}
                                alt={`${selectedKurum.name} ${index + 1}`}
                                style={{ width: "200px", height: "140px", objectFit: "cover", borderRadius: "12px" }}
                                onError={(e) => {
                                  gorselYedeginiGoster(e);
                                }}
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                )}
              </div>

              {/* Right Sidebar Column */}
              <div className="col-lg-4">
                <div className="quick-actions-card universal-card universal-shimmer mb-4">
                  <div className="quick-actions-card-pattern universal-pattern" />
                  <div className="quick-actions-card-content">
                    <h4 className="quick-actions-title">🚀 Hızlı İşlemler</h4>
                    <div className="quick-actions-buttons d-flex flex-column gap-2">
                      {selectedKurum.maps_url && (
                        <a
                          href={selectedKurum.maps_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="maps-button universal-button text-center justify-content-center"
                        >
                          <Navigation size={16} />
                          Haritada Gör
                        </a>
                      )}

                      {selectedKurum.phone && (
                        <a
                          href={`tel:${selectedKurum.phone.replace(/\s+/g, "")}`}
                          className="btn btn-outline-success rounded-pill d-flex align-items-center justify-content-center gap-2 py-2 fw-semibold"
                        >
                          <Phone size={16} />
                          {selectedKurum.phone}
                        </a>
                      )}

                      {selectedKurum.website && (
                        <a
                          href={selectedKurum.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-secondary rounded-pill d-flex align-items-center justify-content-center gap-2 py-2 fw-semibold"
                        >
                          <Globe size={16} />
                          Web Sitesini Ziyaret Et
                        </a>
                      )}
                    </div>
                  </div>
                </div>

                <div className="office-stats-card universal-card universal-shimmer">
                  <div className="office-stats-card-pattern universal-pattern" />
                  <div className="office-stats-card-content">
                    <h4 className="office-stats-title">📊 Kurum Bilgileri</h4>
                    <div className="office-stats-list">
                      {selectedKurum.location && (
                        <div className="office-stat-item">
                          <div className="office-stat-label">Lokasyon</div>
                          <div className="office-stat-value">{selectedKurum.location}</div>
                        </div>
                      )}

                      {selectedKurum.discount_rate && (
                        <div className="office-stat-item">
                          <div className="office-stat-label">İndirim Oranı</div>
                          <div className="office-stat-value text-primary fw-bold">
                            {selectedKurum.discount_rate}
                          </div>
                        </div>
                      )}

                      <div className="office-stat-item">
                        <div className="office-stat-label">Durum</div>
                        <div className="office-stat-value text-success d-flex align-items-center gap-1">
                          <CheckCircle size={14} /> Aktif Anlaşma
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderList = () => {
    const { filteredKurumlar, loading, error, searchTerm, selectedCity, kurumlar } = this.state;

    const cities = Array.from(
      new Set(
        kurumlar
          .map((k) => (k.location ? k.location.split(" - ")[0].trim() : ""))
          .filter(Boolean)
      )
    ).sort();

    return (
      <>
        {/* Hero Section */}
        <section className="offices-header">
          <div className="container position-relative z-1">
            <div className="row justify-content-center text-center">
              <div className="col-lg-9 col-md-10">
                <span className="badge bg-white text-primary px-3 py-2 rounded-pill fw-bold mb-3 shadow-sm">
                  🤝 ÖZEL İNDİRİM & AYRICALIKLAR
                </span>
                <h1 className="display-4 text-white fw-bold mb-3">
                  Anlaşmalı Kurumlarımız
                </h1>
                <p className="lead text-white-50 mb-0">
                  Universal Team üyelerine özel sağlık, eğitim, spor ve hizmet sektörlerindeki anlaşmalı kurumlarımızdan cazip indirimlerle yararlanabilirsiniz.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <div className="container py-5">
          {/* Search & Filter Bar */}
          <div className="card border-0 shadow-sm rounded-4 mb-4 p-3 bg-white">
            <div className="row g-3 align-items-center">
              <div className="col-md-7">
                <div className="input-group">
                  <span className="input-group-text bg-transparent border-end-0">
                    <Search size={20} className="text-muted" />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0 ps-0 shadow-none"
                    placeholder="Kurum adı, indirim veya hizmet ara..."
                    value={searchTerm}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </div>
              <div className="col-md-5">
                <select
                  className="form-select shadow-none"
                  value={selectedCity}
                  onChange={this.handleCityChange}
                >
                  <option value="">Tüm Şehirler</option>
                  {cities.map((city, idx) => (
                    <option key={idx} value={city}>
                      {city}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Loading state */}
          {loading && <Loader />}

          {/* Error state */}
          {error && (
            <div className="alert alert-danger rounded-4 p-4 text-center my-4">
              {error}
            </div>
          )}

          {/* Empty State */}
          {!loading && !error && filteredKurumlar.length === 0 && (
            <div className="text-center py-5">
              <div className="mb-3 text-muted">
                <Search size={48} />
              </div>
              <h4 className="fw-bold text-dark">Sonuç Bulunamadı</h4>
              <p className="text-muted">
                Arama kriterlerinize uygun anlaşmalı kurum bulunamadı.
              </p>
            </div>
          )}

          {/* Kurumlar Grid */}
          {!loading && !error && filteredKurumlar.length > 0 && (
            <div className="row g-4">
              {filteredKurumlar.map((item) => {
                const mainImg = this.formatImageUrl(item.image);
                const hasOtherImgs =
                  Array.isArray(item.other_images) && item.other_images.length > 0;
                const totalImgCount =
                  (mainImg ? 1 : 0) + (hasOtherImgs ? item.other_images.length : 0);

                return (
                  <div key={item.id} className="col-lg-4 col-md-6">
                    <div
                      className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden universal-card cursor-pointer"
                      onClick={() => this.handleSelectKurum(item)}
                    >
                      {/* Image Header */}
                      <div
                        className="position-relative bg-light"
                        style={{ height: "220px", overflow: "hidden" }}
                      >
                        {mainImg ? (
                          <img
                            src={mainImg}
                            alt={item.name}
                            className="w-100 h-100"
                            style={{ objectFit: "cover" }}
                            onError={(e) => {
                              gorselYedeginiGoster(e);
                            }}
                          />
                        ) : (
                          <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-light text-muted">
                            <span>Görsel Yok</span>
                          </div>
                        )}

                        {/* Discount Badge */}
                        {item.discount_rate && (
                          <div
                            className="position-absolute top-0 start-0 m-3 px-3 py-1 rounded-pill bg-warning text-dark fw-bold shadow-sm d-flex align-items-center gap-1"
                            style={{ fontSize: "0.85rem" }}
                          >
                            <Tag size={14} />
                            {item.discount_rate}
                          </div>
                        )}

                        {/* Gallery Badge */}
                        {totalImgCount > 1 && (
                          <div
                            className="position-absolute bottom-0 end-0 m-3 px-2 py-1 rounded-3 bg-dark text-white bg-opacity-75 small d-flex align-items-center gap-1"
                            style={{ backdropFilter: "blur(4px)" }}
                          >
                            <Images size={14} />
                            1/{totalImgCount}
                          </div>
                        )}
                      </div>

                      {/* Card Body */}
                      <div className="card-body p-4 d-flex flex-column">
                        <h5 className="fw-bold text-dark mb-2">{item.name}</h5>

                        {item.location && (
                          <div className="text-secondary small mb-3 d-flex align-items-center gap-1">
                            <MapPin size={16} className="text-danger flex-shrink-0" />
                            <span>{item.location}</span>
                          </div>
                        )}

                        {item.description && (
                          <p
                            className="card-text text-muted small mb-3"
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                            }}
                          >
                            {item.description}
                          </p>
                        )}

                        {/* Footer Action */}
                        <div className="mt-auto pt-3 border-top d-flex align-items-center justify-content-between text-primary font-weight-bold">
                          <span className="small fw-bold">Kurum Detaylarını İncele</span>
                          <ChevronRight size={18} />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </>
    );
  };

  render() {
    const { selectedKurum, isGalleryOpen, galleryImages, activeImageIndex, activeKurumName } =
      this.state;

    return (
      <div className="offices-container">
        <SubHeader
          title={selectedKurum ? selectedKurum.name : "Anlaşmalı Kurumlar"}
          breadcrumbs={[
            { name: "Ana Sayfa", link: "/" },
            { name: "Anlaşmalı Kurumlar", link: "/anlasmali-kurumlar" },
            ...(selectedKurum ? [{ name: selectedKurum.name, link: `/anlasmali-kurumlar/${selectedKurum.id}` }] : []),
          ]}
        />
        <Header />

        {selectedKurum ? this.renderKurumDetail() : this.renderList()}

        {/* Photo Gallery Lightbox Overlay */}
        {isGalleryOpen && galleryImages.length > 0 && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.92)",
              backdropFilter: "blur(8px)",
              zIndex: 99999,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px",
            }}
          >
            {/* Top Bar */}
            <div
              className="w-100 d-flex justify-content-between align-items-center text-white px-3"
              style={{ maxWidth: "1200px" }}
            >
              <h5 className="fw-bold mb-0 text-truncate me-3">{activeKurumName}</h5>
              <div className="d-flex align-items-center gap-3">
                <span
                  style={{
                    color: "rgba(255, 255, 255, 0.8)",
                    fontSize: "0.95rem",
                    fontWeight: "500",
                    letterSpacing: "0.5px",
                  }}
                >
                  {activeImageIndex + 1} / {galleryImages.length}
                </span>
                <button
                  type="button"
                  className="btn p-0 d-flex align-items-center justify-content-center border-0 shadow-none"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    transition: "transform 0.2s ease, opacity 0.2s ease",
                    cursor: "pointer",
                  }}
                  onClick={this.closeGallery}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  <X size={28} color="#ff4d4d" strokeWidth={2.5} />
                </button>
              </div>
            </div>

            {/* Center Image Container */}
            <div
              className="position-relative d-flex align-items-center justify-content-center w-100 my-auto"
              style={{ flex: 1, maxWidth: "1200px", maxHeight: "75vh" }}
            >
              <img
                src={galleryImages[activeImageIndex]}
                alt="Galeri"
                className="img-fluid rounded-4 shadow-lg"
                style={{
                  maxHeight: "75vh",
                  maxWidth: "90vw",
                  objectFit: "contain",
                }}
              />

              {galleryImages.length > 1 && (
                <>
                  <button
                    className="btn text-white rounded-circle p-3 d-flex align-items-center justify-content-center border-0 shadow-lg"
                    style={{
                      position: "fixed",
                      left: "30px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "rgba(255, 255, 255, 0.15)",
                      backdropFilter: "blur(6px)",
                      transition: "all 0.2s ease",
                    }}
                    onClick={this.prevImage}
                  >
                    <ChevronLeft size={32} />
                  </button>
                  <button
                    className="btn text-white rounded-circle p-3 d-flex align-items-center justify-content-center border-0 shadow-lg"
                    style={{
                      position: "fixed",
                      right: "30px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "rgba(255, 255, 255, 0.15)",
                      backdropFilter: "blur(6px)",
                      transition: "all 0.2s ease",
                    }}
                    onClick={this.nextImage}
                  >
                    <ChevronRight size={32} />
                  </button>
                </>
              )}
            </div>

            {/* Bottom Thumbnails */}
            {galleryImages.length > 1 && (
              <div className="d-flex gap-2 overflow-auto py-2 px-3 justify-content-center w-100">
                {galleryImages.map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    alt={`Thumbnail ${idx + 1}`}
                    className={`rounded-3 cursor-pointer ${
                      idx === activeImageIndex ? "border border-3 border-primary" : "opacity-50"
                    }`}
                    style={{
                      width: "60px",
                      height: "45px",
                      objectFit: "cover",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                    onClick={() => this.setState({ activeImageIndex: idx })}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        <Footer />
      </div>
    );
  }
}

export default withRouter(AnlasmaliKurumlar);
